import Action from '../Action';

const initialState = {
	loggedIn: false,
	user: undefined,
	token: undefined,
	role: null,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case Action.LOGIN:
			return { ...state, ...action.data, user: action.user, loggedIn: true };
		case Action.LOGOUT:
			return { ...state, user: null, loggedIn: false, role: null, token: null };
		default:
			return state;
	}
};
